import { type PhotoBankStore } from 'stores/photoBankStore/PhotoBankStore'
import { readOutsideReaction } from 'utils/mobx/readOutsideReaction'

export type PhotoSourceLookup = Pick<PhotoBankStore, 'getRemotePhotoAsync'>

// Waits for the photo's upload; nothing when it failed or isn't in the bank.
export async function resolvePhotoBankSource(
  photoBankStore: PhotoSourceLookup,
  uid: string
) {
  const photo = await photoBankStore.getRemotePhotoAsync(uid)
  if (!photo) return undefined
  return readOutsideReaction(() => ({
    url: photo.originalUrl,
    width: photo.width,
    height: photo.height,
  }))
}
